import React, {useState} from 'react';
import styled from '@emotion/styled';
import {theme} from '../../themes/default-theme';
import {Grid, Box} from '@mui/material';
import Typography from '@mui/material/Typography';
import Moment from 'moment';

import Banner from '../../components/multimedia/Banner';
import {Links, Cta, RespImg} from '../../components/ui';

import topoPng from '../../assets/topo-block-blue-small.png';
import chevronLeft from '../../assets/icons/chevron-left-white.svg';
import SocialShare from '../../components/ui/SocialShare';


const TopWrapper = styled.div`
	max-width: 1600px;
	position: relative;
  background-color: ${theme.palette.white};
	padding: 30px 0;
	margin: 0 auto;

  ${theme.breakpoints.up('md')} {
		padding: 60px 0;
  }
  ${theme.breakpoints.up('lg')} {
		padding: 120px 0;
	}

	&:before {
		content: '';
		background: url('${topoPng}');
		background-size: contain;
		position: absolute;
		left: 0px;
		top: 54px;
		width: 405px;
		height: 226px;

		${theme.breakpoints.down('sm')} {
			display: none;
		}
	}
	
	& .socials-container {
		
	}
`

const BottomWrapper = styled.div`
  background-color: ${theme.palette.lightGrey};
  padding: 30px 0;

  ${theme.breakpoints.up('md')} {
		padding: 60px 0;
  }

  ${theme.breakpoints.up('lg')} {
		padding: 120px 0;
	}

`

const Wrapper = styled.div`

`

const PageContainer = styled.div`
  max-width: 1400px;
  font-weight: 700;
  margin: 0 auto;
  & .hide-for-large {
    ${theme.breakpoints.up('md')} {
      display: none;
    }
  }
  & .hide-for-small {
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  }
` 

const BottomContainer = styled.div`
  max-width: 780px;
  font-weight: 700;
  margin: 0 auto;

	${theme.breakpoints.down('sm')} {
		padding-left: 15px;
		padding-right: 15px;
	}
` 

const LinkItems = styled.div`
	text-align: right;
  margin-top: 25px;

  a {
    display: inline-block;
  }
`

const LinkItem = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
`

const TextContainer = styled.div`
	position: relative;
  height: 100%;

	${theme.breakpoints.up('md')} {
		margin-left: 34px;
		min-height: 370px;
	}
` 

const CareerTitle = styled.div`
  font-size: 28px;
	font-weight: 700;
	padding-top: 20px;
  color: ${theme.palette.charcoal};

  ${theme.breakpoints.down('sm')} {
		font-size: 14px;
		padding-top: 14px;
  }
` 

const CareerImg = styled.div`
  width: 100%;
	border-top-left-radius: 100px;
	position: relative;
	overflow: hidden;

  ${theme.breakpoints.down('sm')} {
    margin-bottom: 26px;
  }
` 

const CategoryContainer = styled.div`
	margin-top: 10px;
	margin-bottom: 10px;
` 

const Category = styled.div`
	text-transform: uppercase;
	color: ${theme.palette.vividBlue};
	display: inline;
	margin-right: 10px;
	padding-right: 10px;
	border-right: 1px solid ${theme.palette.darkGrey};
` 

const Date = styled.div`
	text-transform: uppercase;
	display: inline;
` 

const CareerDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${theme.palette.gunmentalGrey};
  margin-bottom: 26px;

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }

  strong a,
  a strong {
    background: ${theme.palette.vividBlue};
    border-radius: 24px;
    border: 0;
    color: white;
    font-size: 17px;
    width: 100%;
    padding: 10px 30px;
    text-transform: none;
    text-decoration: none;
    display: inline-block;
    width: auto;

    &:hover {
      background-color: ${theme.palette.vividBlueHover};
    }
  }
` 

const AboutTitle = styled.div`
	text-transform: uppercase;
	color: ${theme.palette.charcoal};

	${theme.breakpoints.up('md')} {
		font-size: 30px;
		letter-spacing: 6px;
	}

	${theme.breakpoints.down('sm')} {
		text-align: center;
		font-size: 12px;
		letter-spacing: 1.6px;
	}
` 

const BodyText = styled.div`
	font-size: 16px;
	font-weight: 400;

	${theme.breakpoints.down('sm')} {
		font-size: 14px;

		ul,
		ol {
			font-size: 14px;
		}
	}
` 

const TextContainerBox = styled(Box)`
  height: 100%;
` 

const CareerContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
`

const CareerCta = styled.div`
  margin-bottom: 20px;
`

const CareersPage = (props) => {
	const width = props.width;

  return (
    <Wrapper>
      {props.heroBanner &&
          <Banner
              {...props.heroBanner}
              type="mediumBanner"
          />
}
      <Grid container className={'hasPadding'} spacing={0} direction={'row'}>
          <Grid size={12}>
              <Box px={2}>
                  <Typography>
        <LinkItems>
          <LinkItem>
            <SocialShare />
          </LinkItem>
          <LinkItem>
            <Links href="/careers" svg={chevronLeft}>
              Go back
            </Links>
          </LinkItem>
        </LinkItems>
                  </Typography>
              </Box>
          </Grid>
      </Grid>
      <TopWrapper>
  <PageContainer>
    <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="wrap" alignItems={'normal'}>
                  <Grid
                    size={{
                      xs: 12,
                      md: 7
                    }}>
                      <Box px={2}>
                          {props.imgFiltered &&
                              <CareerImg>
                                  <RespImg
                                      {...props.imgFiltered}
                                  />
                              </CareerImg>
                          }
                      </Box>
      </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 5
                    }}>
                      <TextContainer>
                          {(props.title || props.brief) &&
                              <TextContainerBox px={2}>
              <CareerContent>
                <div>
                  {props.title && <CareerTitle dangerouslySetInnerHTML={{ __html: props.title }} />}
                    <CategoryContainer>
                      <Category>{props.category}</Category>
                      <Date>{props.date}</Date>
                    </CategoryContainer>
                  {props.brief && <CareerDescription dangerouslySetInnerHTML={{ __html: props.brief }} />}
                </div>
                {(props.link && props.link.url) &&
                  <CareerCta>
                    <Cta 
                      href={props.link.url} 
                      target={'_blank'}
                      inline
                      >
                        {props.link.title}
                    </Cta>
                  </CareerCta>
                }
              </CareerContent>
                              </TextContainerBox>
                          }
                      </TextContainer>
                  </Grid>
    </Grid>
  </PageContainer>
</TopWrapper>
      {props.about &&
        <BottomWrapper>
          <BottomContainer>
            <AboutTitle>About the position</AboutTitle>
            <BodyText dangerouslySetInnerHTML={{ __html: props.about }} />
            {(props.link && props.link.url) &&
              <Cta 
                href={props.link.url} 
                target={'_blank'}
                inline
                >
                  {props.link.title}
              </Cta>
            }
          </BottomContainer>
        </BottomWrapper>
      }
    </Wrapper>
  );
}

export default CareersPage;